import { IPlannerEventModel } from "../models/plannerEventModel";

// Swipe / desktop row actions of the planner list. A locked class (another
// instructor's, for an employee who may not open those) gets none of them.

export const canEditPlannerEvent = (item: IPlannerEventModel) =>
  !item.isCancelled && !item.isLocked;

export const canDeletePlannerEvent = (item: IPlannerEventModel) =>
  !item.isCancelled && !item.isLocked;

export const canRestorePlannerEvent = (item: IPlannerEventModel) =>
  item.isCancelled && !item.isLocked;
